module.exports = __webpack_public_path__ + "img/socio8.1c65b1f3.png";